import { IIconBase } from '..'

const EditIcon = ({
  color = '#292D32',
  height = 20,
  width = 20,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M3720 4629 c-145 -22 -268 -78 -393 -179 -40 -32 -637 -624 -1329
-1316 l-1256 -1259 -15 -70 c-210 -975 -249 -1167 -243 -1200 9 -46 57 -101
103 -116 19 -6 54 -9 77 -6 30 4 983 207 1186 252 27 7 2526 2496 2609 2600
279 349 224 860 -121 1131 -169 132 -408 195 -618 163z m223 -324 c243 -51
410 -294 369 -537 -23 -139 -59 -193 -275 -413 l-192 -196 -340 341 -340 340
201 200 c174 174 209 204 266 229 110 50 197 60 311 36z m-688 -1736 c-198
-198 -628 -625 -955 -949 l-596 -588 -423 -91 c-233 -50 -425 -90 -427 -88 -1
1 38 194 88 427 l90 425 951 953 952 952 340 -340 340 -340 -360 -361z'
        />
      </g>
    </svg>
  )
}

export default EditIcon
